<template>
  <div>
    <vue-headful title="Beschikbaarheid" />
    <Header page_title="Beschikbaarheid" menuClass="invisible" />
      <div v-if="initialized || sub_branch" class="container-fluid app-body">
      <form @change="onFormChange" @submit.prevent="onSubmit">
        <div class="container-fluid px-0 pb-1 mb-2">
          <NotificationContainer />

          <div class="mb-3">
            <b class="clearfix mb-0" v-on:click="partOpen = partOpen.includes('distance') ? partOpen.filter(x => x !== 'distance') : partOpen.concat('distance')">
              <span class="sd-title mini bold accordeon">
                <span class="title-text">
                  <span v-if="partOpen.includes('distance')" class="accordeon-icon">-</span>
                  <span v-else class="accordeon-icon">+</span>
                  Wat is je maximale reisafstand?
                </span>
              </span>
            </b>
            <div v-if="partOpen.includes('distance')">
              <small class="d-block mb-2">Afstand (km) vanaf {{ userAddress.street }} {{ userAddress.street_number }}{{ userAddress.house_addition }}, {{ userAddress.postal_code }}, {{ userAddress.city }}.</small>
              <VueSlideBar
                ref="slider"
                v-model="search_distance"
                :min="0"
                :max="100"
              >
                <template slot="tooltip">
                  <div class="range-tooptip"></div>
                  <div class="tooptip value" v-html="search_distance"></div>
                </template>
              </VueSlideBar>
              <div class="range-values clearfix">
                <div class="float-left">
                  <small>0km</small>
                </div>
                <div class="float-right">
                  <small>100km</small>
                </div>
              </div>
            </div>
          </div>

          <div>
            <p class="mb-3" v-on:click="partOpen = partOpen.includes('availability') ? partOpen.filter(x => x !== 'availability') : partOpen.concat('availability')">
              <!-- Select only the days you can work. -->
              <span class="sd-title mini bold accordeon">
                <span class="title-text">
                  <span v-if="partOpen.includes('availability')" class="accordeon-icon">-</span>
                  <span v-else class="accordeon-icon">+</span>
                    Welke tijden/dagdelen ben je beschikbaar?
                </span>
              </span>
            </p>
          </div>
          <div v-if="partOpen.includes('availability') && sub_branch !== '2' && branch !== '3'">
            <p class="mb-2">
              <strong>Selecteer 6 maanden vooruit</strong>
            </p>
            <div class="form-group days-select">
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  id="quickselect1"
                  value="All"
                  class="custom-control-input"
                  v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect1">Alle</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  id="quickselect2"
                  value="Mon"
                  class="custom-control-input"
                  v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect2">Ma</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  id="quickselect3"
                  value="Tue"
                  class="custom-control-input"
                  v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect3">Di</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  id="quickselect4"
                  value="Wed"
                  class="custom-control-input"
                  v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect4">Wo</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  id="quickselect5"
                  value="Thu"
                  class="custom-control-input"
                  v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect5">Do</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  id="quickselect6"
                  value="Fri"
                  class="custom-control-input"
                  v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect6">Vr</label>
              </div>
            </div>
            <div class="mb-0 search-unavailable-through" v-if="!isNotAvailableThroughDateInFuture() && !unavailableThroughButtonClicked">
              <button type="button" class="btn btn-gray days-select" style="height: auto; line-height: 23px;" v-on:click.prevent="unavailableThroughButtonClicked=true">Ik ben de komende tijd niet beschikbaar</button>
            </div>
            <div v-if="isNotAvailableThroughDateInFuture() || unavailableThroughButtonClicked">
              <div>
                <p class="mb-3">
                  <strong>Ik ben tot deze datum niet beschikbaar</strong><br />
                  Ben je de komende tijd niet beschikbaar? Geef hieronder dan de datum op tot wanneer je niet beschikbaar bent. <span v-if="this.branch == 2">Kinderopvangorganisaties</span><span v-else>Scholen</span> zien je niet meer als kandidaat en je ontvangt tot die datum geen verzoeken meer om je beschikbaarheid op te geven. Wil je deze datum aanpassen? Klik dan nogmaals op de datum en geef een nieuwe datum op.
                </p>
              </div>
              <div class="mb-4 search-unavailable-through-datepicker">
                <keep-alive>
                  <v-date-picker
                      locale="nl"
                      mode="date"
                      v-model="form.search_unavailable_through"
                      :first-day-of-week="week"
                      :min-date="minDate"
                      :max-date="maxDate"
                      :available-dates="availableDates"
                      ref="calendarInstance"
                  ></v-date-picker>
                </keep-alive>
              </div>
            </div>
            <div class="syncfusion-calendar mb-4 mt-2">
              <div class="icon-wrapper arrow-back">
                <i class="material-icons-round">arrow_back</i>
              </div>
              <div class="icon-wrapper arrow-forward">
                <i class="material-icons-round">arrow_forward</i>
              </div>
              <keep-alive>
                <v-date-picker
                  locale="nl"
                  mode="multiple"
                  v-model="dates"
                  :first-day-of-week="week"
                  :min-date="minDate"
                  :max-date="maxDate"
                  :available-dates="availableDates"
                  :disabled-dates="disableDates"
                  ref="calendarInstance"
                  is-expanded
                  is-inline
                ></v-date-picker>
              </keep-alive>
            </div>
            <div class="mb-4 row">
              <div class="col-sm-7">
                <div class="mb-1">
                  <span class="legend hired">1</span>&nbsp;<span>Je werkt op deze dagen voor Derect</span>
                </div>
                <div class="mb-1">
                  <span class="legend available">1</span>&nbsp;<span>Je bent beschikbaar op deze dagen</span>
                </div>
                <div v-if="isNotAvailableThroughDateInFuture()" class="mb-1">
                  <span class="legend unavailable">1</span>&nbsp;<span>Je bent op deze dagen niet beschikbaar</span>
                </div>
                <div v-if="isNotAvailableThroughDateInFuture()">
                  <span class="legend long-not-available">1</span>&nbsp;<span>Je bent deze periode niet beschikbaar</span>
                </div>
                <div class="mb-1">
                  <span class="legend empty">1</span>&nbsp;<span>Geen beschikbaarheid opgegeven</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="partOpen.includes('availability') && sub_branch === '2' && branch !== '3'">
            <div class="form-group days-select">
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                    type="checkbox"
                    id="quickselect2"
                    value="Mon"
                    class="custom-control-input"
                    v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect2">Maandag</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                    type="checkbox"
                    id="quickselect3"
                    value="Tue"
                    class="custom-control-input"
                    v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect3">Dinsdag</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                    type="checkbox"
                    id="quickselect4"
                    value="Wed"
                    class="custom-control-input"
                    v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect4">Woensdag</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                    type="checkbox"
                    id="quickselect5"
                    value="Thu"
                    class="custom-control-input"
                    v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect5">Donderdag</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                    type="checkbox"
                    id="quickselect6"
                    value="Fri"
                    class="custom-control-input"
                    v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect6">Vrijdag</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline">
                <input
                    type="checkbox"
                    id="quickselect1"
                    value="All"
                    class="custom-control-input"
                    v-on:change="switchSelect"
                />
                <label class="custom-control-label" for="quickselect1">Ik ben flexibel</label>
              </div>
              <div class="mb-0 search-unavailable-through custom-control-inline" v-if="!isNotAvailableThroughDateInFuture() && !unavailableThroughButtonClicked">
                <button type="button" class="btn btn-gray days-select" style="height: auto; line-height: 23px;" v-on:click.prevent="unavailableThroughButtonClicked=true">Ik ben de komende tijd niet beschikbaar</button>
              </div>
            </div>
            <div v-if="isNotAvailableThroughDateInFuture() || unavailableThroughButtonClicked">
              <div>
                <p class="mb-3">
                  <strong>Ik ben tot deze datum niet beschikbaar</strong><br />
                  Ben je de komende tijd niet beschikbaar? Geef hieronder dan de datum op tot wanneer je niet beschikbaar bent. <span v-if="this.branch == 2">Kinderopvangorganisaties</span><span v-else>Scholen</span> zien je niet meer als kandidaat en je ontvangt tot die datum geen verzoeken meer om je beschikbaarheid op te geven. Wil je deze datum aanpassen? Klik dan nogmaals op de datum en geef een nieuwe datum op.
                </p>
              </div>
              <div class="mb-4 search-unavailable-through-datepicker">
                <keep-alive>
                  <v-date-picker
                      locale="nl"
                      mode="date"
                      v-model="form.search_unavailable_through"
                      :first-day-of-week="week"
                      :min-date="minDate"
                      :max-date="maxDate"
                      :available-dates="availableDates"
                      ref="calendarInstance"
                  ></v-date-picker>
                </keep-alive>
              </div>
            </div>
          </div>
            <div v-if="partOpen.includes('availability') && branch === '3'">
                <div class="form-group days-select">
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                            type="checkbox"
                            id="Day"
                            value="day"
                            class="custom-control-input"
                            v-model="healthcareDates"
                            @change="nonFlexibleChange"
                        />
                        <label class="custom-control-label" for="Day">Dag</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                            type="checkbox"
                            id="Evening"
                            value="evening"
                            class="custom-control-input"
                            v-model="healthcareDates"
                            @change="nonFlexibleChange"
                        />
                        <label class="custom-control-label" for="Evening">Avond</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                            type="checkbox"
                            id="Night"
                            value="night"
                            class="custom-control-input"
                            v-model="healthcareDates"
                            @change="nonFlexibleChange"
                        />
                        <label class="custom-control-label" for="Night">Nacht</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                            type="checkbox"
                            id="Weekend"
                            value="weekend"
                            class="custom-control-input"
                            v-model="healthcareDates"
                            @change="nonFlexibleChange"
                        />
                        <label class="custom-control-label" for="Weekend">Weekend</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                            type="checkbox"
                            id="Flex"
                            value="isFlexible"
                            class="custom-control-input"
                            v-model="healthcareDates"
                            @change="flexibleChange"
                        />
                        <label class="custom-control-label" for="Flex">Ik ben flexibel</label>
                    </div>
                </div>

                <div class="clearfix">
                    <div class="float-left">
                        <div class="custom-control custom-switch">
                            <input
                                type="checkbox"
                                id="OwnTransport"
                                value="hasTransport"
                                class="custom-control-input"
                                v-model="healthcareDates"
                            />
                            <label
                                class="custom-control-label"
                                for="OwnTransport"
                            ></label>
                        </div>
                    </div>
                    <div class="float-left">
                        <label class="toggle-label" for="notification_newsletter">Ik beschik over eigen vervoer</label>
                    </div>
                </div>
            </div>
        </div>
        <button type="submit" class="btn btn-warning btn-block">Opslaan</button>
      </form>
    </div>
    <Footer />
  </div>
</template>

<script>
import VueSlideBar from "vue-slide-bar";

export default {
  components: {
    VueSlideBar
  },
  data() {
    return {
      form: {
        search_availability: [],
        search_unavailable_through: null
      },
      availableDates: null,
      sub_branch: localStorage.getItem("subBranch"),
      minDate: "",
      maxDate: "",
      week: 2,
      ongoing: [],
      dates: [],
      quick: [],
      prevRoute: null,
      search_distance: 0,
      All_switch: false,
      Mon_switch: false,
      Tue_switch: false,
      Wed_switch: false,
      Thu_switch: false,
      Fri_switch: false,
      unavailableThroughButtonClicked: false,
      search_unavailable_through: null,
      searchUnavailableThroughOverlapsWithAvailableDates: false,
      branch: 0,
      healthcareDates: [],
      partOpen: ["availability", "distance"],
      userAddress: {
        street: "",
        street_number: "",
        house_addition: "",
        postal_code: "",
        city: ""
      },
      initialized: false,
    };
  },
  async created() {
      this.$store.state.loading = true;
    //   console.log(this.$router.currentRoute)
  },
  async mounted() {
    var minDate = new Date();
    minDate.setHours(0, 0, 0, 0);
    minDate.setDate(minDate.getDate());
    this.minDate = minDate;

    var maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 6);
    maxDate.setHours(0, 0, 0, 0);
    this.maxDate = maxDate;

    const ongoingDates = await this.getTokenAPIList("jobs/ongoing");
    this.ongoing = ongoingDates.ongoing;
    await this.getCalendarDates(true);
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    dates: {
      immediate: true,
      handler: function() {
        this.quick = [];
        this.formatDates();
        this.sortDateArray();
      },
      deep: true
    }
  },
  methods: {
    updateQuickSelectCheckboxes() {
      let days = {
        Mon: false,
        Tue: false,
        Wed: false,
        Thu: false,
        Fri: false
      };

      this.dates.forEach(date => {
        let day = date.toString().slice(0, 3);
        if (days.hasOwnProperty(day)) {
          days[day] = true;
        }
      });

      this.Mon_switch = days.Mon;
      this.Tue_switch = days.Tue;
      this.Wed_switch = days.Wed;
      this.Thu_switch = days.Thu;
      this.Fri_switch = days.Fri;

      document.getElementById("quickselect2").checked = days.Mon;
      document.getElementById("quickselect3").checked = days.Tue;
      document.getElementById("quickselect4").checked = days.Wed;
      document.getElementById("quickselect5").checked = days.Thu;
      document.getElementById("quickselect6").checked = days.Fri;

      document.getElementById("quickselect1").checked =
          days.Mon && days.Tue && days.Wed && days.Thu && days.Fri;
    },
    quickSelectDates(day, addit) {
      this.quick = [];
      for (var i in this.availableDates) {
        let val = this.availableDates[i].toString();
        let el_day = val.slice(0, 3);
        if (el_day == day && this.availableDates[i].getTime() > (new Date().getTime() - (24*60*60*1000))) {
          this.quick.push(this.availableDates[i]);
        }
      }
      var _ctr;
      var _quickDates = [];
      var _oldDates = [];
      var _newDates = [];
      for (_ctr = 0; _ctr < this.quick.length; _ctr++) {
        let _date = String(this.quick[_ctr]);
        _quickDates.push(_date);
      }
      for (_ctr = 0; _ctr < this.dates.length; _ctr++) {
        let _date = String(this.dates[_ctr]);
        _oldDates.push(_date);
      }

      if (addit) {
        _quickDates.forEach(function(val) {
          if (!_oldDates.includes(val)) {
            _newDates.push(new Date(val));
          }
        });
      } else {
        _oldDates.forEach(function(val) {
          if (!_quickDates.includes(val)) {
            _newDates.push(new Date(val));
          }
        });
        this.dates = [];
      }
      this.dates = this.dates.concat(_newDates);
    },
      async flexibleChange() {
          if (this.healthcareDates.includes("isFlexible")) {
              if (this.healthcareDates.includes("hasTransport")) {
                  this.healthcareDates = [];
                  this.healthcareDates.push("hasTransport");
                  this.healthcareDates.push("isFlexible");
              } else {
                  this.healthcareDates = [];
                  this.healthcareDates.push("isFlexible");
              }
          }
      },
      nonFlexibleChange() {
          // If a non-flexible option is selected, ensure 'isFlexible' is deselected
          const nonFlex = ["day", "evening", "night", "weekend"];
          const hasNonFlex = this.healthcareDates.some(v => nonFlex.includes(v));
          if (hasNonFlex && this.healthcareDates.includes("isFlexible")) {
              // Remove only 'isFlexible' while keeping other selections (and hasTransport if present)
              this.healthcareDates = this.healthcareDates.filter(v => v !== "isFlexible");
          }
      },
    async fetchData() {
      this.branch = localStorage.getItem("branch");
      await this.autoFillForm();
      this.$forceUpdate();
      this.initialized = true;
      this.$store.state.loading = false;
    },
    async autoFillForm() {
      return new Promise(resolve => {
        // format and assign the dates on the calendar
        const user = JSON.parse(localStorage.getItem("user"));

        this.search_distance = user.search_distance;

        this.userAddress.street         = user.street;
        this.userAddress.street_number  = user.street_number;
        this.userAddress.house_addition = user.house_addition;
        this.userAddress.postal_code    = user.postal_code;
        this.userAddress.city           = user.city;

          if (user.healthcare_availability) {
              let saved = JSON.parse(user.healthcare_availability);
              this.healthcareDates = Object.keys(saved).filter(key => saved[key] === true);
          }

        if (user.search_availability) {
          var searchAvailability = JSON.parse(user.search_availability);
          this.form.search_availability = searchAvailability;
          for (var key in searchAvailability) {
            let _date = searchAvailability[key];
            _date = _date.split('-');
            let _y = parseInt(_date[0]);
            let _m = parseInt(_date[1]) - 1; //january starts with 0
            let _d = parseInt(_date[2]);
            // _date = new Date(searchAvailability[key] + " 00:00:00"); //yyy-mm-dd is wrong format
            _date = new Date(_y, _m, _d, 0, 0, 0);
            if (_date.getTime() > (new Date().getTime() - (24*60*60*1000))) {
              this.dates.push(_date);
            }
          }
          if(this.sub_branch === '2') {
            this.updateQuickSelectCheckboxes();
          }
        }
        if (user.search_unavailable_through) {
          let _date = user.search_unavailable_through;
          _date = _date.split('-');
          let _y = parseInt(_date[0]);
          let _m = parseInt(_date[1]) - 1; //january starts with 0
          let _d = parseInt(_date[2]);
          _date = new Date(_y, _m, _d, 0, 0, 0);
          this.form.search_unavailable_through = _date;
          this.search_unavailable_through = _date;
        }
        resolve({});
      });
    },
    async updateHealthcareUser() {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            //make a json object with all the items in healthcareDates and put them on true if there in there
            let healthcareAvailability = {};
            for (var i = 0; i < this.healthcareDates.length; i++) {
                healthcareAvailability[this.healthcareDates[i]] = true;
            }
            formData.append("healthcare_availability", JSON.stringify(healthcareAvailability));
            if(this.form['search_unavailable_through'] != "" && this.form['search_unavailable_through'] != null) {
                var _search_unavailable_through = this.formatDate(this.form['search_unavailable_through']);
                formData.append("search_unavailable_through", _search_unavailable_through);
            }

            const user_token = JSON.parse(localStorage.getItem("user-token"));
            const url = this.$apiURI + "/applicant";
            this.$http
                .post(url, formData, {
                    headers: {
                        Authorization: "Bearer " + user_token,
                        Accept: "application/json"
                    }
                })
                .then(() => {
                    // console.log(success);
                    localStorage.removeItem("form-pending");

                    let notificationMessage = "Je hebt je gegevens succesvol aangepast.";

                    const notification = {
                        type: "success",
                        message: notificationMessage
                    };
                    this.$store.dispatch("notification/replace", notification, {
                        root: true
                    });
                    this.$store.state.loading = false;
                    resolve();
                })
                .catch(() => {
                    // console.log(error);
                    const notification = {
                        type: "danger",
                        message: "Er is een fout opgetreden.",
                        error: true
                    };
                    this.$store.dispatch("notification/replace", notification, {
                        root: true
                    });
                    this.$store.state.loading = false;
                    reject();
                });
        });
    },
    async updateUser() {
      // console.log("async updateUser()");
      return new Promise((resolve, reject) => {
        this.$store.state.loading = true;
        this.formatDates();

        let formData = new FormData();
        for (var obj in this.form) {
          // formData.append(obj, this.form[obj]);
          if (obj == "search_availability") {
            var _search_availability = this.form[obj];
            if (_search_availability.length) {
              for (var i = 0; i < _search_availability.length; i++) {
                formData.append("search_availability[]", _search_availability[i]);
              }
            } else {
              formData.append("search_availability[]", '');
            }
          } else if (obj == "search_unavailable_through") {
            if(this.form[obj] != "" && this.form[obj] != null) {
              var _search_unavailable_through = this.formatDate(this.form[obj]);
              formData.append("search_unavailable_through", _search_unavailable_through);
            }
          }
        }

        formData.append("search_distance", this.search_distance);

        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/applicant";
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            localStorage.removeItem("form-pending");

            let notificationMessage = "Je hebt je gegevens succesvol aangepast. ";

            if (this.searchUnavailableThroughOverlapsWithAvailableDates) {
              const Moment = require("moment");
              let search_unavailable_through_string = new Moment(this.form.search_unavailable_through).format("DD-MM-YYYY");
              notificationMessage = "Je hebt aangegeven tot en met " + search_unavailable_through_string + " niet beschikbaar te zijn, maar er zijn data in deze periode waarop je had aangegeven beschikbaar te zijn. Deze data zijn verwijderd. Je hebt je gegevens succesvol aangepast.";
              this.searchUnavailableThroughOverlapsWithAvailableDates = false;
            }

            const notification = {
              type: "success",
              message: notificationMessage
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });

            if (typeof dataLayer !== "undefined") {
              const dataLayerEvent = {
                event: "TeacherAvailabilityEdit",
                eventCategory: "Teacher",
                eventAction: "Teacher - Availability edit",
                eventLabel: "",
                eventValue: "1"
              };
              dataLayer.push(dataLayerEvent);
            }

            this.search_unavailable_through = this.form.search_unavailable_through;
            this.$store.state.loading = false;
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject();
          });
      });
    },
    async onSubmit() {
      window.scrollTo(0, 0);
      if (this.branch === '3') {
          await this.updateHealthcareUser();
          await this.updateLocalUser();
          await this.redirectBack();
      } else {
          if (this.noOverlappingDatesFound()) {
            await this.updateUser();
            // continue only if resolve()
            await this.updateLocalUser();
            await this.redirectBack();
          }
      }
    },
    async redirectBack() {
      return new Promise(() => {
        if (this.prevRoute && this.prevRoute.name && (!this.currentRoute || this.prevRoute.name != this.currentRoute.name)) {
          setTimeout(() =>
            this.$router.replace({
              name: this.prevRoute.name
            }),
            800
          );
        } else {
          setTimeout(() =>
            this.$router.go(),
            800
          );
        }
      });
    },
    async formatDates() {
      return new Promise(resolve => {
        this.form.search_availability = [];
        for (var key in this.dates) {
          this.form.search_availability.push(this.formatDate(this.dates[key]));
        }
        resolve();
      });
    },
    disableDates: function(args) {
      if (args.weekday == 2 || args.weekday == 3 || args.id == this.formatDate(new Date().getTime())) {
        args.isDisabled = true;
      }

      var ymd = args.id;
      if (this.ongoing.indexOf(ymd) > -1) {
        args.classes.push('taken');
        args.isDisabled = true;
      }

      // Get current unavailable through date
      const user = JSON.parse(localStorage.getItem("user"));
      if (user.search_unavailable_through) {
        let _date = user.search_unavailable_through;
        _date = _date.split('-');
        let _y = parseInt(_date[0]);
        let _m = parseInt(_date[1]) - 1; //january starts with 0
        let _d = parseInt(_date[2]);
        _date = new Date(_y, _m, _d, 0, 0, 0);
        this.form.search_unavailable_through = _date;
      }

      if (this.form.search_unavailable_through && ymd && (new Date().getTime() - (24*60*60*1000)) < this.form.search_unavailable_through.getTime()) {
        let _ymd = ymd.split('-');
        let _y = parseInt(_ymd[0]);
        let _m = parseInt(_ymd[1]) - 1; //january starts with 0
        let _d = parseInt(_ymd[2]);
        // _date = new Date(searchAvailability[key] + " 00:00:00"); //yyy-mm-dd is wrong format
        _ymd = new Date(_y, _m, _d, 0, 0, 0);

        if (_ymd.getTime() - (24*60*60*1000) < this.form.search_unavailable_through.getTime()) {
          args.classes.push('unavailable');
        }
      }

      return args;
    },
    getCalendarDates(force) {
      if ((this.minDate && this.maxDate && !this.availableDates) || typeof force !== "undefined") {
        this.availableDates = this.getDateArray(
          new Date(this.minDate),
          new Date(this.maxDate)
        );
      }
    },
    sortDateArray() {
      const Moment = require("moment");
      const array = this.form.search_availability;
      const sortedArray = array.sort((a, b) => new Moment(a).format("YYYYMMDD") - new Moment(b).format("YYYYMMDD"));
      if (this.form.search_availability) {
        this.form.search_availability = sortedArray;
      }
    },
    getDateArray(start, end) {
      var arr = [];
      var dt = new Date(start);
      while (dt <= end) {
        var day = dt.getDay();
        var isOngoing = false;
        if (this.ongoing.length) {
          // var ymd = dt.toISOString().split('T')[0];
          var ymd = dt.toLocalISOString().split("T")[0];
          if (this.ongoing.indexOf(ymd) > -1) {
            isOngoing = true;
          }
        }
        var isWeekend = day === 6 || day === 0; // 6 = Saturday, 0 = Sunday
        if (isWeekend || isOngoing || (this.form.search_unavailable_through && dt.getTime() < this.form.search_unavailable_through.getTime() + (24*60*60*1000))) {
          // skip
        } else {
          arr.push(new Date(dt));
        }
        dt.setDate(dt.getDate() + 1);
      }
      return arr;
    },
    onFormChange() {
      localStorage.setItem("form-pending", JSON.stringify(true));
    },
    switchSelect(el) {
      var _val = el.target.value;
      let targetSwitch = _val + "_switch";
      this[targetSwitch] = el.target.checked;

      if (!this[targetSwitch]) {
        if (_val == "All") {
          //unchecked //false
          this.dates = [];
          document.getElementById("quickselect2").checked = this.Mon_switch = false;
          document.getElementById("quickselect3").checked = this.Tue_switch = false;
          document.getElementById("quickselect4").checked = this.Wed_switch = false;
          document.getElementById("quickselect5").checked = this.Thu_switch = false;
          document.getElementById("quickselect6").checked = this.Fri_switch = false;
        } else {
          this.quickSelectDates(_val, false);
        }
      } else {
        //checked // true
        if (_val == "All") {
          document.getElementById("quickselect2").checked = this.Mon_switch = true;
          document.getElementById("quickselect3").checked = this.Tue_switch = true;
          document.getElementById("quickselect4").checked = this.Wed_switch = true;
          document.getElementById("quickselect5").checked = this.Thu_switch = true;
          document.getElementById("quickselect6").checked = this.Fri_switch = true;
          if (!this.availableDates) {
            this.getCalendarDates();
          }
          this.dates = this.availableDates;
        } else {
          this.quickSelectDates(_val, true);
        }
      }
    },
    isNotAvailableThroughDateInFuture() {
      if (this.search_unavailable_through) {
        if (this.search_unavailable_through.getTime() > (new Date().getTime() - (24*60*60*1000)))
          return true;
        else
          return false;
      }
      else
        return false;
    },
    noOverlappingDatesFound() {
      this.$store.state.loading = true;

      if (!this.form.search_unavailable_through)
        return true;

      let noOverlappingDatesFound = true;

      for (var i in this.ongoing) {
        let _date = this.ongoing[i];
        _date = _date.split('-');
        let _y = parseInt(_date[0]);
        let _m = parseInt(_date[1]) - 1; //january starts with 0
        let _d = parseInt(_date[2]);
        _date = new Date(_y, _m, _d, 0, 0, 0);

        // Conflict with hired days => show error message
        if (_date.getTime() < this.form.search_unavailable_through.getTime() + (24*60*60*1000)) {
          const Moment = require("moment");

          let search_unavailable_through_string = new Moment(this.form.search_unavailable_through).format("DD-MM-YYYY");

          const notification = {
            type: "danger",
            message: "Je hebt aangegeven tot en met " + search_unavailable_through_string + " niet beschikbaar te zijn, maar er zijn data in deze periode waarop je voor Derect aan het werk bent. De data kon om deze reden niet worden opgeslagen."
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });

          noOverlappingDatesFound = false;

          break;
        }
      }

      if (!noOverlappingDatesFound) {
        this.$store.state.loading = false;
        return noOverlappingDatesFound;
      }

      // Conflict with available days => show info message
      for (var j in this.dates) {
        if (this.dates[j].getTime() < this.form.search_unavailable_through.getTime() + (24*60*60*1000)) {
          this.searchUnavailableThroughOverlapsWithAvailableDates = true;
          break;
        }
      }

      this.$store.state.loading = false;

      return true;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.savePending(to, from, next);
  }
};
</script>

<style scoped>
.sd-header-space {
  margin-top: 45px !important;
}

.legend {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  height: 20px;
  width: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
}

.legend.hired {
  border: 2px solid #FFCD00;
  background-color: #FFCD00;
}

.legend.available {
  border: 2px solid #FFCD00;
  background-color: #FFF;
}

.legend.unavailable,
.legend.long-not-available {
  border: 2px solid #FF5A5A;
  background-color: #FFF;
}

.form-group.days-select {
  margin-bottom: 0;
}

.days-select .custom-control {
  text-decoration: none;
}

.btn.btn-gray.days-select,
.days-select .custom-control .custom-control-label {
  background-color: #FFF;
  border: 2px solid #F6F6F6;
  border-radius: 5px;
  padding: 7px 15px;
  color: #64513D;
  font-weight: 200;
  margin-bottom: 15px;
  font-size: 14px;
  line-height: 1;
}

.days-select .custom-control input:checked + .custom-control-label {
  border: 2px solid #FFCD00;
  background-color: #FFCD00;
  color: #FFF;
}

.vue-slide-bar-component {
  margin-top: -10px;
}
.range-values div {
  position: relative;
  margin-top: -2px;
}
.range-values .float-left {
  left: -3px;
}
.range-values .float-right {
  right: -8px;
}

.sd-title.accordeon {
  cursor: pointer;
}

.accordeon .accordeon-icon {
  display: flex;
  background-color: #FFCD00;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  margin-right: 15px;
  cursor: pointer;
}

input.require-calendar {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: -1;
}
.custom-checkbox .custom-control-label::before {
  display: none;
}
.custom-checkbox .custom-control-label::after {
  display: none;
}
.custom-control {
  padding-left: 0;
  margin-right: 15px;
  text-decoration: underline;
}
.custom-control-label {
  cursor: pointer;
}
.search-unavailable-through-datepicker {
  position: relative;
}
.long-not-available {
  position: relative;
}
.long-not-available::after {
  content: "*";
  position: absolute;
  top: -3px;
  right: 0;
  font-size: 13px;
  font-weight: 200;
}

@media(max-width:575px) {

}
</style>
